import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import Toggle from 'react-toggle';
import FontAwesome from 'react-fontawesome';
import $ from 'jquery';

export class Endpoint extends BaseComponent {
  constructor(props) {
    super(props);

    let onOff = false;
    if (this.props.endpoint.OnOff) {
      if (this.props.endpoint.OnOff.OnOff) {
        onOff = true;
      }
    }

    this.state = {
      endpoint: this.props.endpoint,
      endpointIndex: this.props.endpointIndex,
      token: this.props.token,
      deviceID: this.props.deviceID,
      ieee: this.props.ieee,
      open: false,
      onOff: onOff,
      tunnelURL: this.props.tunnelURL,
    };
    this.toggleAccordion = this.toggleAccordion.bind(this);
    this.toggleOnOff = this.toggleOnOff.bind(this);
  }

  renderToggleClass() {
    if (this.state.open) {
      return 'single-device single-device--toggle single-device--open';
    }
    return 'single-device single-device--toggle';
  }

  toggleAccordion() {
    this.setState({ open : !this.state.open });
  }

  renderDeviceType() {
    return this.state.endpoint.DeviceType;
  }

  getProfileName() {
    const profileName = this.state.endpoint.ProfileName ? (
      <div className="single-device__content__data__row">
        <div className="single-device__content__data__row__label">Profile Name</div>
        <div className="single-device__content__data__row__content">{ this.state.endpoint.ProfileName }</div>
      </div>
    ) : (
      ''
    );
    return profileName;
  }

  getManufacturerName() {
    const manufacturerName = this.state.endpoint.Basic && this.state.endpoint.Basic.ManufacturerName ? (
      <div className="single-device__content__data__row">
        <div className="single-device__content__data__row__label">Manufacturer Name</div>

        <div className="single-device__content__data__row__content">{ this.state.endpoint.Basic.ManufacturerName }</div>
      </div>
    ) : (
      ''
    );
    return manufacturerName;
  }

  getModelIdentifier() {
    const modelIdentifier = this.state.endpoint.Basic && this.state.endpoint.Basic.ModelIdentifier ? (
      <div className="single-device__content__data__row">
        <div className="single-device__content__data__row__label">Model Identifier</div>
        <div className="single-device__content__data__row__content">{ this.state.endpoint.Basic.ModelIdentifier }</div>
      </div>
    ) : (
      ''
    );
    return modelIdentifier;
  }

  getId() {
    const id = this.state.endpoint.Id ? (
      <div className="single-device__content__data__row">
        <div className="single-device__content__data__row__label">Id</div>
        <div className="single-device__content__data__row__content">{ this.state.endpoint.Id }</div>
      </div>
    ) : (
      ''
    );
    return id;
  }

  getDeviceId() {
    const deviceId = this.state.endpoint.DeviceId ? (
      <div className="single-device__content__data__row">
        <div className="single-device__content__data__row__label">Device Id</div>
        <div className="single-device__content__data__row__content">{ this.state.endpoint.DeviceId }</div>
      </div>
    ) : (
      <div className="single-device__content__data__row">
        <div className="single-device__content__data__row__label">Device Id</div>
        <div className="single-device__content__data__row__content">0</div>
      </div>
    );
    return deviceId;
  }

  getBattery() {
    let battery;
    if (this.state.endpoint.PowerConfiguration && this.state.endpoint.PowerConfiguration.hasOwnProperty('BatteryVoltageMinThreshold')) {
      let val;
      let min = this.state.endpoint.PowerConfiguration.BatteryVoltageMinThreshold;
      let current = this.state.endpoint.PowerConfiguration.BatteryVoltage;
      if (current <= min) {
        val = 0;
      }
      let max;
      if (this.state.endpoint.PowerConfiguration.BatteryRatedVoltage) {
        max = this.state.endpoint.PowerConfiguration.BatteryRatedVoltage;
      } else {
        max = min * 1.4;
      }
      if (current >= max) {
        val = 4;
      }
      if (val !== false) {
        val = Math.floor(1 + 3 * (current - min) / (max - min));
      }
      let batteryClass = "battery battery--" + val;

      if (max !== min) {
        battery = (
          <div className="single-device__content__data__row">
            <div className="single-device__content__data__row__label">Battery</div>
            <div className="single-device__content__data__row__content">
              <div className={ batteryClass }>
                <span className="battery__size"></span>
              </div>
            </div>
          </div>
        );
      }
    }
    return battery;
  }

  getEndpoint() {
    const endpoint = (
      <div className="single-device__content__data__row">
        <div className="single-device__content__data__row__label">Endpoint</div>
        <div className="single-device__content__data__row__content">{ this.state.endpointIndex }</div>
      </div>
    );
    return endpoint;
  }

  toggleOnOff(e) {
    let checked = e.target.checked;
    let command = 'Off';
    if (checked) {
      command = 'On';
    }
    $.ajax({
      method: 'POST',
      url: this.state.tunnelURL + '/zigbee/json',
      headers: {
        'x-session': this.props.token,
      },
      xhrFields: {
        withCredentials: true
      },
      data: JSON.stringify({
        Address: this.state.ieee,
        Command: command,
      }),
      dataType: 'JSON',
      success: (res) => {},
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });

    this.setState({ onOff: checked });
  }

  getOnOff() {
    let onOff;
    if (this.state.endpoint.OnOff) {
      onOff = (
        <div className="single-device__content__data__row">
          <div className="single-device__content__data__row__label">On / Off</div>
          <div className="single-device__content__data__row__content">
            <Toggle
              checked={ this.state.onOff }
              onChange={ this.toggleOnOff }
            />
          </div>
        </div>
      );
    }
    return onOff;
  }
  renderMonitoring() {
    if (this.state.showMonitoring) {
      return(
        <Toggle
          checked={this.state.monitoring}
          onChange={this.toggleMonitoring}
        />
      );
    }
    return(
      <div>Caricamento dati...</div>
    );
  }

  render() {
    return(
      <div className={ this.renderToggleClass() }>
        <div onClick={ this.toggleAccordion } className="single-device__topbar">{ this.renderDeviceType() } <FontAwesome name="plus" className="single-device__topbar__plus" /></div>
        <div className="single-device__content">
          <div className="single-device__content__data">
            { this.getEndpoint() }
            { this.getDeviceId() }
            { this.getId() }
            { this.getProfileName() }
            { this.getManufacturerName() }
            { this.getModelIdentifier() }
            { this.getOnOff() }
            { this.getBattery() }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Endpoint.js